import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const scheduleDetails = createAsyncThunk('scheduleDetails', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `online_class_schedule/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const scheduleDetailsSlice = createSlice({
    name: 'scheduleDetails',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(scheduleDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action?.payload?.data?.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate);
            } else {
                state.data = [];
            }
        });
        builder.addCase(scheduleDetails.rejected, (state, action) => {
        })
    }
})

export default scheduleDetailsSlice.reducer;
